import { render, staticRenderFns } from "./SystemPolicy.vue?vue&type=template&id=7f6006d6&scoped=true&"
import script from "./SystemPolicy.vue?vue&type=script&lang=js&"
export * from "./SystemPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6006d6",
  null
  
)

export default component.exports